import moment from "moment";

const getHours = (hrs) => {
  const roundedTotalHours = Math.round(hrs * 100) / 100;

  const hours = Math.floor(roundedTotalHours);
  const minutes = Math.round((roundedTotalHours % 1) * 60);

  const totalString = `${hours}:${minutes.toString().padStart(2, "0")}`;

  return totalString;
};

const convertToExcel = (data, typeD, ASCexcelData) => {
  console.log("asc22 Excel Data", data);
  console.log("asc22 ASC Excel Data", ASCexcelData);

  if (typeD === "worktime") {
    const excelXml = `<?xml version="1.0"?>
  <?mso-application progid="Excel.Sheet"?>
  <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
    xmlns:o="urn:schemas-microsoft-com:office:office"
    xmlns:x="urn:schemas-microsoft-com:office:excel"
    xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
    xmlns:html="http://www.w3.org/TR/REC-html40">
    <Worksheet ss:Name="Sheet1">
      <Table>
        <Row>
          <Cell><Data ss:Type="String">ProjectName</Data></Cell>
          <Cell><Data ss:Type="String">TaskName</Data></Cell>
          <Cell><Data ss:Type="String">TrackerStartDate</Data></Cell>
          <Cell><Data ss:Type="String">TrackerStartTime</Data></Cell>
          <Cell><Data ss:Type="String">TrackerEndDate</Data></Cell>
          <Cell><Data ss:Type="String">TrackerEndTime</Data></Cell>
          <Cell><Data ss:Type="String">Type</Data></Cell>
          <Cell><Data ss:Type="String">Description</Data></Cell>
          <Cell><Data ss:Type="String">TotalHours</Data></Cell>
          <!-- Add more headers as needed -->
        </Row>
      
        
            ${data
              .map(
                (task) => `
              <Row>
                <Cell><Data ss:Type="String">${task.projectName}</Data></Cell>
                <Cell><Data ss:Type="String">${task.taskName}</Data></Cell>
                <Cell><Data ss:Type="String">${
                  task.trackerStartDate
                }</Data></Cell>
                <Cell><Data ss:Type="String">${
                  task.trackerStartTime
                }</Data></Cell>
                <Cell><Data ss:Type="String">${
                  task.trackerEndDate
                }</Data></Cell>
                <Cell><Data ss:Type="String">${
                  task.trackerEndTime
                }</Data></Cell>
                <Cell><Data ss:Type="String">${task.type}</Data></Cell>
                <Cell><Data ss:Type="String">${task.description}</Data></Cell>
                <Cell><Data ss:Type="String">${getHours(
                  task.totalHours
                )}</Data></Cell>
                <!-- Add more cells based on your data structure -->
              </Row>
            `
              )
              .join("")}
          
       
      </Table>
    </Worksheet>
  </Workbook>
  `;

    // for pdf print download start.
    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    // let selectedClientName = localStorage.getItem("clientNameForPrint");
    let employeeName = localStorage.getItem("firstname");

    let pdfTitle = `${employeeName}-Worktime Report,-${workspaceName}-${moment(
      new Date()
    ).format("YYYY.MM.DD, h:mm a")}.xls`;
    // for pdf print download end.

    // Convert the XML string to Blob
    const blob = new Blob([excelXml], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a link element and trigger a download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = pdfTitle;

    // Append the link to the document and trigger a click
    document.body.appendChild(link);
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
    return null;
  }

  if (typeD === "worktime-underData") {
    const workTimeUnderData = `<?xml version="1.0"?>
    <?mso-application progid="Excel.Sheet"?>
    <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:x="urn:schemas-microsoft-com:office:excel"
      xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:html="http://www.w3.org/TR/REC-html40">
      <Worksheet ss:Name="Sheet1">
        <Table>
          <Row>
            <Cell><Data ss:Type="String">FirstName</Data></Cell>
            <Cell><Data ss:Type="String">LastName</Data></Cell>
            <Cell><Data ss:Type="String">ProjectName</Data></Cell>
            <Cell><Data ss:Type="String">TaskName</Data></Cell>
            <Cell><Data ss:Type="String">TrackerStartDate</Data></Cell>
            <Cell><Data ss:Type="String">TrackerStartTime</Data></Cell>
            <Cell><Data ss:Type="String">TrackerEndDate</Data></Cell>
            <Cell><Data ss:Type="String">TrackerEndTime</Data></Cell>
            <Cell><Data ss:Type="String">Type</Data></Cell>
            <Cell><Data ss:Type="String">Description</Data></Cell>
            <Cell><Data ss:Type="String">TotalHours</Data></Cell>
            <Cell><Data ss:Type="String">IsApproved</Data></Cell>
            <!-- Add more headers as needed -->
          </Row>
          ${data
            .map(
              (user) => `
            ${user.dateWiseTasksList
              .map(
                (tasks) => `
              ${tasks
                .map(
                  (task) => `
                <Row>
                  <Cell><Data ss:Type="String">${user.firstName}</Data></Cell>
                  <Cell><Data ss:Type="String">${user.lastName}</Data></Cell>
                  <Cell><Data ss:Type="String">${task.projectName}</Data></Cell>
                  <Cell><Data ss:Type="String">${task.taskName}</Data></Cell>
                  <Cell><Data ss:Type="String">${
                    task.trackerStartDate
                  }</Data></Cell>
                  <Cell><Data ss:Type="String">${
                    task.trackerStartTime
                  }</Data></Cell>
                  <Cell><Data ss:Type="String">${
                    task.trackerEndDate
                  }</Data></Cell>
                  <Cell><Data ss:Type="String">${
                    task.trackerEndTime
                  }</Data></Cell>
                  <Cell><Data ss:Type="String">${task.type}</Data></Cell>
                  <Cell><Data ss:Type="String">${task.description}</Data></Cell>
                  <Cell><Data ss:Type="String">${getHours(
                    task.totalHours
                  )}</Data></Cell>
                  <Cell><Data ss:Type="String">${task.isApproved}</Data></Cell>
                  <!-- Add more cells based on your data structure -->
                </Row>
              `
                )
                .join("")}
            `
              )
              .join("")}
          `
            )
            .join("")}
        </Table>
      </Worksheet>
    </Workbook>
    `;

    const ASCexcelXml = `<?xml version="1.0"?>
    <?mso-application progid="Excel.Sheet"?>
    <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:x="urn:schemas-microsoft-com:office:excel"
      xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
      xmlns:html="http://www.w3.org/TR/REC-html40">
      <Worksheet ss:Name="Sheet1">
        <Table>
          <Row>
            <Cell><Data ss:Type="String">FirstName</Data></Cell>
            <Cell><Data ss:Type="String">LastName</Data></Cell>
            <Cell><Data ss:Type="String">Week</Data></Cell>
            <Cell><Data ss:Type="String">TrackerStartDate</Data></Cell>
            <Cell><Data ss:Type="String">TrackerEndDate</Data></Cell>
            <Cell><Data ss:Type="String">totalHours</Data></Cell>
            <Cell><Data ss:Type="String">totalWages</Data></Cell>
            <Cell><Data ss:Type="String"></Data></Cell>
            <Cell><Data ss:Type="String">IsApproved</Data></Cell>
            <!-- Add more headers as needed -->
          </Row>
          ${ASCexcelData?.map((item) => {
            return `
               <Row>
                  <Cell><Data ss:Type="String">${item.firstName}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.lastName}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.weekNumber}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.weekStart}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.weekEnd}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.totalHours}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.totalWage}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.diffrence}</Data></Cell>
                  <Cell><Data ss:Type="String">${item.isApproved}</Data></Cell>
                  
                  <!-- Add more cells based on your data structure -->
                </Row>
              `;
          })}
        </Table>
      </Worksheet>
    </Workbook>
    `;

    // for pdf print download start.
    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    // let selectedClientName = localStorage.getItem("clientNameForPrint");
    let employeeName = localStorage.getItem("firstname");

    let pdfTitle2 = `${employeeName}-Worktime Report,-${workspaceName}-${moment(
      new Date()
    ).format("YYYY.MM.DD, h:mm a")}.xls`;
    // for pdf print download end.

    // Convert the XML string to Blob.
    // const blob = new Blob([excelXml], {
    // const blob = new Blob([ASCexcelXml], {
    const blob = new Blob([workTimeUnderData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a link element and trigger a download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = pdfTitle2;

    // Append the link to the document and trigger a click
    document.body.appendChild(link);
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  }
};

export { convertToExcel };
